import styled from 'styled-components';
import ReactDatePicker from 'react-datepicker';

const DateFilterWrapper = styled.div`
  .react-datepicker-popper {
    z-index: 2;
  }
  display: flex;
  align-items: center;
  .filter {
    margin-right: 1em;
    .rw-widget {
      margin-top: 0;
    }
  }
`;

const NavigationButton = styled.button`
  min-width: 40px;
  height: 40px;
  padding: 0;
  border-radius: 4px;
  cursor: pointer;
  border: solid 2px ${p => p.theme.color.primary};
  background-color: ${p => p.theme.color.bg_white};
  .right {
    transform: rotate(180deg);
  }
`;

const DatePicker = styled(ReactDatePicker)`
  margin: 0 1em;
  font-family: ${p => p.theme.fontFamily};
  font-size: 16px;
  padding: 10px 10px;
  border: solid 1px ${p => p.theme.color.border};
  border-radius: 4px;
  min-width: 130px;
  width: calc(100% - 80px - 2em);
  color: transparent;
  text-shadow: 0 0 0 ${p => p.theme.color.text};
  &:focus {
    outline: none;
  }
`;

export { NavigationButton, DatePicker, DateFilterWrapper };
